import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { TournamentProvider } from './context/TournamentContext';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/main.css';

// Create React 18 root and render
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <TournamentProvider>
        <App />
      </TournamentProvider>
    </ErrorBoundary>
  </React.StrictMode>
);